import script from "./AlreadyPaid.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlreadyPaid.vue?vue&type=script&setup=true&lang=ts"

export default script